export {FooterLogo} from './lib/footer-logo';